const LANDING_ORIGIN =
  process.env.REACT_APP_LANDING_ORIGIN?.replace(/\/$/, '') || 'https://www.useskipscreen.com';

export const LANDING_LEGAL_URLS = {
  termsOfService: `${LANDING_ORIGIN}/terms-of-service.html`,
  communityStandards: `${LANDING_ORIGIN}/community-standards.html`,
  candidateContentPolicy: `${LANDING_ORIGIN}/candidate-content-policy.html`,
  privacyPolicy: `${LANDING_ORIGIN}/privacy-policy.html`,
} as const;
